import React, { useState, useEffect, useRef, useCallback, useContext } from 'react'
import CallToAction from '../Core/CallToAction'
import { Form, FormSpy } from 'react-final-form';
import { useNavigate } from "react-router-dom";
import { useTheme } from '../context/ThemeContext'
import useScreenSize from '../context/useScreenSize';

import FileUploader from '../Core/FileUploader';
import InternalLocationSearchInput from '../Core/Inputs/LocationSearchInput';
import SelectableBox from '../Core/SelectableBox';
import MultiFields from '../Core/MultiFields';
import Info from '../Core/Info';
import { GlobalContext } from '../context/GlobalContext';
import MembershipContainer from '../Membership/MembershipContainer';
import RenderImages from '../Core/RenderImages';
import FormActions from '../Core/FormActions';
import { isRequired, composeValidators } from '../utils/validators';
import CreateNewClientContainer from '../Clients/CreateNewClientContainer';
import ConditionalRender from '../Core/ConditionalRender';
import ConfirmModal from '../Core/ConfirmModal';
import ExtraFields from './ExtraFields';
import AutocompleteDropdown from '../Core/Inputs/AutocompleteDropdown';
import CreateProjectModals from './CreateProjectModals';
import Wrapper from '../Core/Wrapper';
import {
    createUser,
    setRole,
    createProjectImages,
    createProjectFiles,
    updateFields,
    updateHistory
} from '../utils/calls'
import InventoryCreateContainer from '../Invetory/InventoryCreateContainer';
import base64ToBlob from '../utils/base64ToBlob';
import { isEmpty } from 'lodash';
import { createProject } from '../utils/calls'
import { useLanguage } from '../context/LanguageContext';
import { useToast } from '../context/ToastContext'
import colors from '../globalStyles.scss'
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const StyledDiv = styled.div`

    .image-uploader {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .dropzone {
            display: flex;
            flex-direction: column;
            margin: 0.5em 0;
            padding: 1em;
            background: ${props => props.theme === 'dark' ? colors.secondary : colors.darkGray};
            cursor: pointer;
            transition: all 0.2s ease 0s;
            &:hover {
                background: ${colors.lightGray};
            }
            span {
                font-family: ${colors.openSans};
                color: ${props => props.theme === 'dark' ? colors.black : colors.black};
            }
        }
    }

`;


const CreateProjectContainer = ({
    user,
    company,
    fetchCompanyEmployees,
    employees,
    employeesIsLoading,
    fetchCompanyProjects,
    fieldNames,
    categories,
    inventory,
    inventoryColumns,
    fetchInventoryProducts,
    fetchInventoryCategories,
    fetchAttributes,
    fetchFieldNames,
    projects,
    categoryRecommendationData,
    fetchAllClients,
    clients,
    clientsIsLoading,
    isLoggedIn,
    fetchUserDetails,
    fetchCompanyDetails,
}) => {
    const { MAX_IMAGES, UPLOAD_LIMIT } = useContext(GlobalContext);
    const { theme } = useTheme();


    const navigate = useNavigate();
    const { text } = useLanguage();
    const { notify } = useToast();
    const { isDesktop, isTablet } = useScreenSize();
    const formRef = useRef();
    const inputRef = useRef(null); // Create a ref for the input

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);


    const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
    const [assignEmployee, setAssignEmployee] = useState(false);
    const [assignClient, setAssignClient] = useState(false);
    const [addEmployee, setAddEmployee] = useState(false);
    const [addClient, setAddClient] = useState(false);

    const [roleType, setRoleType] = useState('Employee');
    const [error, setError] = useState('');

    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedClients, setSelectedClients] = useState({});
    const [adminEmployees, setAdminEmployees] = useState([]);
    const [selectedDesigns, setSelectedDesigns] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [newProject, setNewProject] = useState({})
    const [features, setFeatures] = useState({
        inventory: true,
        client: true,
        proposals: true
    })
    const [duplicatedFields, setDuplicatedFields] = useState({});
    const [fieldNameAndValues, setFieldNameAndValues] = useState([]);
    const [formattedFieldNames, setFormattedFieldNames] = useState(fieldNames);
    const [fields, setFields] = useState([]);

    const [imageError, setImageError] = useState('')
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const removeImage = (imageIndex) => {
        setSelectedDesigns((prevImages) => {
            const updatedImages = prevImages?.filter((image, index) => index !== imageIndex);
            return updatedImages;
        });
    };

    const openCarousel = (index) => {
        setActiveIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onDrop = useCallback(async (acceptedFiles, id) => {
        const imageFiles = acceptedFiles?.filter(file => file.type.startsWith('image/'));

        if (imageFiles?.length !== acceptedFiles?.length) {
            setImageError(text?.projects?.details?.validations?.onlyImages);
            return;
        }

        setSelectedDesigns((prevImages) => {
            if (prevImages?.length >= MAX_IMAGES) {
                setImageError(`${text?.projects?.create?.uploader?.validations?.upto} ${MAX_IMAGES} ${text?.projects?.create?.uploader?.images}`);
                return prevImages;
            }

            // If we already have x new images, block any further uploads
            const newImagesCount = prevImages?.filter(img => img.new)?.length;
            if (newImagesCount >= UPLOAD_LIMIT) {
                setImageError(`${text?.projects?.create?.uploader?.validations?.uploadUpTo} ${UPLOAD_LIMIT} ${text?.projects?.create?.uploader?.validations?.atAtime}`);
                return prevImages;
            }

            // Ensure that only x new images are added at a time
            const remainingSlots = Math.min(UPLOAD_LIMIT - newImagesCount, MAX_IMAGES - prevImages?.length);
            const filesToUpload = imageFiles.slice(0, remainingSlots);

            if (filesToUpload?.length === 0) return prevImages;

            Promise.all(
                filesToUpload.map((file) => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();

                        reader.onloadend = () => {
                            resolve({ file, url: reader.result, originalName: file.name });
                        };

                        reader.readAsDataURL(file);
                    });
                })
            ).then((newUploadedImages) => {
                setSelectedDesigns([
                    ...newUploadedImages.map((img) => ({ url: img.url, originalName: img.originalName, new: true })),
                    ...prevImages,
                ]);
                setImageError('');
            });

            return prevImages;
        });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            'image/jpeg': ['.jpeg', '.jpg'],
            'image/png': ['.png'],
            'image/gif': ['.gif'],
            'image/bmp': ['.bmp'],
            'image/svg+xml': ['.svg']
        },
        multiple: true
    });


    useEffect(() => {
        const extracLabel = fieldNames?.map((x) => {
            return x.label
        })
        setFormattedFieldNames([...new Set(extracLabel)])
    }, [fieldNames])



    const required = composeValidators(
        isRequired(text?.projects?.create?.validations?.required),
    );

    // Validator to check if the project name already exists
    const projectNameExists = value => {
        const nameExists = projects?.some(
            project => project?.projectName.toLowerCase() === value?.toLowerCase()
        );
        return nameExists ? text?.projects?.create?.validations?.exists : undefined;
    };

    const nameValidation = composeValidators(
        isRequired(text?.projects?.create?.validations?.required),
        projectNameExists

    )

    const handleDesignsSelect = (imageData) => {
        setSelectedDesigns(imageData)
    };

    const handleFilesSelect = (files) => {
        setSelectedFiles(files)
    };

    const handleAssignEmployee = () => {
        setAssignEmployee(!assignEmployee)
    };

    const handleAssignClient = () => {
        setAssignClient(!assignClient)
    };

    const setNewClient = (client) => {
        setSelectedClients(client)
    }

    const createNewEmployee = async (values) => {
        values.companyId = company?.id
        values.companyName = company?.companyName
        values.companyIndustry = {
            value: company?.companyIndustry
        }
        const permissions = ['read', 'write']
        setAddEmployee(false)

        setRole({
            companyId: company?.id,
            roleName: roleType,
            permissions
        })
            .then((userRes) => {
                const roleId = userRes?.data?.id
                const roleName = userRes?.data?.roleName
                const companyId = userRes?.data?.companyId
                return createUser({
                    ...values,
                    roleId,
                    roleName,
                    companyId
                })
            }).then((res) => {
                if (res.status === 200) {
                    const newEmployee = res.data?.user
                    fetchCompanyEmployees(company?.id)
                    handleEmployeeSelection(newEmployee)
                }
            })
            .catch((error) => {
                console.error(error);
                setError(error);
            });
    };


    const [showEmployeesFilters, setShowEmployeesFilters] = useState(false);
    const [showClientsFilters, setShowClientsFilters] = useState(false);
    const [searchEmployeeQuery, setSearchEmployeeQuery] = useState('');
    const [searchClientQuery, setSearchClientQuery] = useState('');
    const [employeesList, setEmployeesList] = useState(employees);
    const [clientsList, setClientsList] = useState(clients);

    const handleSearchEmployeeChange = (e) => {
        setSearchEmployeeQuery(e.target.value);
    };

    const handleSearchClientChange = (e) => {
        setSearchClientQuery(e.target.value);
    };

    const handleFeaturesChange = (feature) => {
        setFeatures((prev) => ({
            ...prev,
            [feature]: !prev[feature]
        }));
    };

    const handleEmployeeSelection = (employee) => {
        if (selectedEmployees.some((e) => e._id === employee._id)) {
            setSelectedEmployees((prev) => prev.filter((e) => e._id !== employee._id));
            setAdminEmployees((prev) => prev.filter((e) => e._id !== employee._id)); // Remove from adminEmployees if unchecked
        } else {
            setSelectedEmployees((prev) => [...prev, employee]);
        }
    };

    const handleClientSelection = (client) => {
        setSelectedClients(client);
    }

    const handleAdminSelection = (employee) => {
        const isAlreadyAdmin = adminEmployees.some((e) => e._id === employee._id);

        if (isAlreadyAdmin) {
            setAdminEmployees((prev) => prev.filter((e) => e._id !== employee._id));
        } else {
            if (selectedEmployees.some((e) => e._id === employee._id)) {
                setAdminEmployees((prev) => [...prev, employee]);
            } else {
                console.error("Employee must be selected before being marked as an admin.");
            }
        }
    };

    useEffect(() => {
        if (searchEmployeeQuery) {
            const query = searchEmployeeQuery.toLowerCase();
            const filteredEmployees = employees.filter((employee) => {
                // Combine first name and last name for comprehensive search
                const fullName = `${employee?.firstName} ${employee?.lastName} (${employee.email})`.toLowerCase();
                return fullName.includes(query);
            });
            setEmployeesList(filteredEmployees);
        } else {
            setEmployeesList(employees);
        }

        if (searchClientQuery) {
            const query = searchClientQuery.toLowerCase();
            const filteredClients = clients.filter((client) => {
                return client?.name?.toLowerCase().includes(query);
            });
            setClientsList(filteredClients);
        } else {
            setClientsList(clients);
        }
    }, [searchEmployeeQuery, employees, clients, searchClientQuery]);

    const [inventoryIsCreating, setInventoryIsCreating] = useState(false);

    /*
        // Project Form Submission
    */
    const [showSubscriptionOptions, setShowSubscriptionOptions] = useState(false);
    const onSubmit = async (values) => {

        if (company?.trialIsActive && projects.length >= 3) {
            setShowSubscriptionOptions(true);
            return;
        }

        delete values?.fieldName
        delete values?.inputType

        if (values?.advanceFields) {
            // remove null values from object
            Object.keys(values?.advanceFields).forEach(key => {
                if (values?.advanceFields[key] === null || values?.advanceFields[key] === '') {
                    delete values?.advanceFields[key];
                }
            });
        }

        values.assignedEmployees = selectedEmployees?.map((employee) => {
            return {
                id: employee._id
            };
        });

        values.adminEmployees = adminEmployees?.map((employee) => {
            return {
                id: employee._id
            };
        });

        if (!isEmpty(selectedClients)) {
            values.client = selectedClients?._id
        }

        values.features = features;

        try {
            setIsLoading(true); // Set loading state to true

            const res = await createProject(values);
            if (res.status === 200) {
                const projectId = res.data?.project?.id;
                setNewProject(res.data?.project);

                // Process and upload product images
                const imageUploadPromises = selectedDesigns?.map(async (image) => {
                    const imageBlob = base64ToBlob(image?.url); // Convert base64 data to a Blob
                    const formData = new FormData();
                    formData.append("image", imageBlob, image?.originalName); // Add the Blob to FormData, along with a file name
                    formData.append("projectId", projectId);

                    // Send the image to a separate endpoint
                    return createProjectImages(formData)
                        .then((imageRes) => {
                            if (imageRes?.status === 200) {
                                console.log("Image uploaded");
                            } else {
                                throw new Error("Image upload failed");
                            }
                        });
                }) || [];

                // Create file upload promises
                const fileUploadPromises = selectedFiles?.map(async (file) => {
                    const formData = new FormData();
                    formData.append('file', file); // Add the file to FormData
                    formData.append('projectId', projectId);
                    // Send the file to the createProjectFiles endpoint
                    return createProjectFiles(formData)
                        .then((fileRes) => {
                            if (fileRes?.status === 200) {
                                console.log("File uploaded");
                            } else {
                                throw new Error("File upload failed");
                            }
                        });
                }) || [];

                const fieldRes = await updateFields(fieldNameAndValues);
                if (fieldRes.status === 200) {
                    console.log("Fields updated");
                }

                // Combine both image and file upload promises into a single array
                const allUploadPromises = [
                    ...imageUploadPromises,
                    ...fileUploadPromises
                ];

                // Wait for all uploads to complete
                await Promise.all(allUploadPromises);
                updateHistory(projectId, text?.projects?.history?.projectCreated)
                notify(text?.notificationsUI?.project?.created, 'success');

                const fetchPromises = [];
                if (fetchCompanyProjects) {
                    fetchPromises.push(fetchCompanyProjects(company?.id));
                }
                if (fetchAttributes) {
                    fetchPromises.push(fetchAttributes());
                }
                if (fetchFieldNames) {
                    fetchPromises.push(fetchFieldNames());
                }

                await Promise.all(fetchPromises);

                if (!inventoryIsCreating) {
                    if (projectId === '000000000000000000000000') {
                        setIsLoading(false);
                        navigate('/')
                    } else {
                        setIsLoading(false);
                        navigate(`/project/details?id=${projectId}`);
                    }
                }
            }
        } catch (error) {
            setIsLoading(false);
            notify(`Error: ${error.message}`, 'error');
            console.error("Error submitting form:", error);
        }
    };

    const [toggleModal, setToggleModal] = useState(false);


    const handleToggle = (e) => {
        e?.preventDefault()
        setToggleModal(prevToggleModal => !prevToggleModal);
    }
    const resetForm = () => {
        formRef?.current.reset();
        handleToggle();
        navigate('/')

    }

    const [spyValues, setSpyValues] = useState();

    return (
        <ConditionalRender renderIf={true} isLoading={isLoading}>
            <StyledDiv
                theme={theme}
                className={isDesktop ? 'desktop' : isTablet ? 'tablet' : 'phone'}
            >
                {
                    <Form
                        onSubmit={onSubmit}
                        render={({ handleSubmit, form, submitting, pristine }) => {
                            formRef.current = form;

                            return (
                                <form onSubmit={handleSubmit}>
                                    <FormSpy subscription={{ values: true }}>
                                        {({ values, form }) => {
                                            setSpyValues(values);
                                        }}
                                    </FormSpy>
                                    <div>
                                        <h4 className='tx-left'>
                                            {text?.projects?.landing?.createNew}
                                        </h4>
                                        <p className='small mt-md tx-left'>
                                            {text?.projects?.create?.employeeInfo}
                                        </p>
                                        <hr />
                                    </div>

                                    {/* Info */}
                                    <Wrapper
                                        isLoading={isLoading}
                                    >
                                        <MultiFields
                                            className='field-style'
                                            name="projectName"
                                            component="text"
                                            label={text?.projects?.create?.name}
                                            block
                                            validate={nameValidation}
                                            inputRef={inputRef}
                                        />
                                        <AutocompleteDropdown
                                            className='field-style'
                                            validate={required}
                                            name={`projectCategory`}
                                            label={text?.projects?.create?.category}
                                            options={categoryRecommendationData}
                                            placeholder={text?.projects?.create?.selectCategory}
                                            noFormat
                                        />
                                        <InternalLocationSearchInput
                                            name="projectLocation"
                                            type={'input'}
                                            label={text?.projects?.create?.location}
                                            showMapLabel={text?.projects?.create?.showMap}
                                        />
                                        <MultiFields
                                            className='field-style'
                                            name="projectDescription"
                                            component="textarea"
                                            type="text"
                                            label={text?.projects?.create?.description}
                                            block
                                            info={<Info
                                                text={text?.projects?.create?.descriptionInfo}
                                                id='projectDescriptionInfo'
                                                placement={'top'}
                                                className='flex justify-center items-center'
                                            />}
                                        />
                                    </Wrapper>

                                    <hr />

                                    {/* Employees */}
                                    <Wrapper
                                        isLoading={isLoading}
                                        title={text?.projects?.create?.employees}
                                        button={

                                            // Assign button
                                            <CallToAction
                                                text={text?.projects?.create?.employeeButton}
                                                type='button'
                                                onClick={() => handleAssignEmployee()}
                                            />
                                        }
                                    >
                                        <ConditionalRender renderIf={!isEmpty(selectedEmployees)}>

                                            <div
                                                className="flex mt-md"
                                                style={{
                                                    flexWrap: 'wrap',
                                                    display: 'flex',
                                                    gap: '5px',
                                                }}
                                            >
                                                {selectedEmployees?.map((employee, index) => (
                                                    <SelectableBox
                                                        block
                                                        key={employee._id}
                                                        className="flex items-center relative"
                                                        style={{
                                                            marginRight: (index + 1) % 3 === 0 ? '0' : '5px',
                                                            marginBottom: '5px',
                                                        }}
                                                        removeButton
                                                        onClickRemove={() => {
                                                            setSelectedEmployees(selectedEmployees.filter((e) => e._id !== employee._id));
                                                            setAdminEmployees(adminEmployees.filter((e) => e._id !== employee._id));
                                                        }}
                                                    >
                                                        <p className="tx-left">
                                                            {`${employee.firstName} ${employee.lastName}`}
                                                            {adminEmployees.some((e) => e._id === employee._id) &&
                                                                ` (${text?.projects?.create?.admin})`}
                                                        </p>
                                                    </SelectableBox>
                                                ))}
                                            </div>

                                        </ConditionalRender>

                                        <ConditionalRender renderIf={isEmpty(selectedEmployees)}>
                                            <p className='mb-md'>
                                                {text?.projects?.create?.notFoundMsgs?.employees}
                                            </p>
                                        </ConditionalRender>
                                    </Wrapper>

                                    <hr />

                                    {/* Clients */}
                                    <Wrapper
                                        isLoading={isLoading}
                                        title={text?.projects?.create?.client}
                                        button={
                                            <ConditionalRender renderIf={!isEmpty(clients)}>
                                                <CallToAction
                                                    text={
                                                        isEmpty(selectedClients) ?
                                                            text?.projects?.details?.clientModal?.assignClient : text?.projects?.details?.clientModal?.changeClient
                                                    }
                                                    type='button'
                                                    onClick={() => handleAssignClient()}
                                                />
                                            </ConditionalRender>
                                        }
                                        secondaryButton={
                                            <CallToAction
                                                className='ml-md'
                                                text={text?.client?.create?.title}
                                                type='button'
                                                onClick={() => setAddClient(!addClient)}
                                            />
                                        }
                                    >
                                        <ConditionalRender renderIf={!isEmpty(selectedClients)}>
                                            <SelectableBox
                                                className='flex items-center mb-md relative'
                                                removeButton
                                                onClickRemove={() => setSelectedClients({})}
                                            >
                                                <p className='tx-left'>
                                                    {`${selectedClients?.name}(${selectedClients?.email})`}
                                                </p>
                                            </SelectableBox>
                                        </ConditionalRender>

                                        <ConditionalRender renderIf={isEmpty(selectedClients)}>
                                            <p className='mb-md'>
                                                {text?.projects?.create?.notFoundMsgs?.client}
                                            </p>
                                        </ConditionalRender>

                                        <ConditionalRender renderIf={addClient}>
                                            <CreateNewClientContainer
                                                isOpen={addClient}
                                                toggle={() => setAddClient(false)}
                                                user={user}
                                                fetchAllClients={fetchAllClients}
                                                setNewClient={setNewClient}
                                                clients={clients}
                                            />
                                        </ConditionalRender>
                                    </Wrapper>

                                    <hr />

                                    {/* designs */}
                                    <Wrapper
                                        title={text?.projects?.details?.designs}
                                        button={
                                            <div className='image-uploader'>
                                                <div
                                                    className='dropzone'
                                                    {...getRootProps()}
                                                >
                                                    <input {...getInputProps()} />
                                                    <span>
                                                        {text?.inventory?.details?.uploadImages}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    >
                                        {
                                            !isEmpty(imageError) && (
                                                <span style={{
                                                    marginTop: '1em',
                                                    color: colors.red
                                                }}>
                                                    {imageError}
                                                </span>
                                            )
                                        }
                                        <ConditionalRender renderIf={!isEmpty(selectedDesigns)}>
                                            <RenderImages
                                                images={selectedDesigns}
                                                removeImage={removeImage}
                                                openModal={openCarousel}
                                                closeModal={closeModal}
                                                setActiveIndex={setActiveIndex}
                                                activeIndex={activeIndex}
                                                isModalOpen={isModalOpen}
                                            />
                                        </ConditionalRender>

                                        <ConditionalRender renderIf={isEmpty(selectedDesigns)}>
                                            <p className='mb-md'>
                                                {text?.projects.create?.notFoundMsgs?.images}
                                            </p>
                                        </ConditionalRender>
                                    </Wrapper>

                                    <hr />

                                    {/* files */}
                                    <FileUploader
                                        onFileUpload={handleFilesSelect}
                                        maxFiles={10}
                                        files={selectedFiles}
                                        customMessage={text?.projects?.create?.orDrag}
                                        title={text?.projects?.details?.filesTitle}
                                        isLoading={isLoading}
                                    />
                                    <hr />

                                    {/* Advance Fields */}
                                    <Wrapper
                                        isLoading={isLoading}
                                        title={
                                            <div className='flex items-center' style={{
                                                fontFamily: colors.openSans,
                                                textAlign: 'left'
                                            }}>
                                                {text?.inventory?.create?.form?.extraFields?.title}
                                                <Info
                                                    text={text?.projects?.info}
                                                    id='advanceField-project'
                                                    placement={'top'}
                                                    className='flex justify-center items-center'
                                                />
                                            </div>
                                        }

                                    >
                                        <ExtraFields
                                            setDuplicatedFields={setDuplicatedFields}
                                            fieldNameAndValues={fieldNameAndValues}
                                            setFieldNameAndValues={setFieldNameAndValues}
                                            form={form}
                                            fieldNames={formattedFieldNames}
                                            setFields={setFields}
                                            fields={fields}
                                        />
                                    </Wrapper>
                                    <hr />

                                    <FormActions
                                        floating
                                        type="submit"
                                        submitText={text?.projects?.create?.button}
                                        secondaryText={text?.projects?.create?.cancel}
                                        form={form}
                                        btnStyle={{
                                            color: colors.blue,
                                        }}
                                        onClick={handleToggle}
                                        controlledTooltipProps={{
                                            "primary": {
                                                isDark: true,
                                                isVisible: isEmpty(projects),
                                                text: text?.actionTracking?.createProjectButton,
                                                placement: 'left',
                                                actionParams: {
                                                    feature: 'formActions',
                                                    action: 'buttonClickPrimary'
                                                }
                                            }
                                        }}
                                    />
                                </form>
                            )
                        }
                        }
                    />
                }

                {/* Inventory */}
                <InventoryCreateContainer
                    company={company}
                    isCreateProject
                    fieldNames={fieldNames}
                    categories={categories}
                    inventory={inventory}
                    inventoryColumns={inventoryColumns}
                    user={user}
                    fetchInventoryProducts={fetchInventoryProducts}
                    fetchInventoryCategories={fetchInventoryCategories}
                    fetchCompanyProjects={fetchCompanyProjects}
                    fetchAttributes={fetchAttributes}
                    projects={projects}
                    newProject={newProject}
                    projectValues={spyValues}
                    setInventoryIsCreating={setInventoryIsCreating}
                    title={text?.projects?.create?.inventory}
                    info={text?.projects?.create?.inventoryInfo}
                    toggle={() => handleFeaturesChange('inventory')}
                    toggleState={features?.inventory}
                    projectIsLoading={isLoading}
                />

                <hr />

                <CreateProjectModals
                    assignEmployee={assignEmployee}
                    handleAssignEmployee={handleAssignEmployee}
                    assignClient={assignClient}
                    handleAssignClient={handleAssignClient}
                    text={text}
                    employees={employees}
                    employeesIsLoading={employeesIsLoading}
                    employeesList={employeesList}
                    user={user}
                    addEmployee={addEmployee}
                    setAddEmployee={setAddEmployee}
                    addClient={addClient}
                    setAddClient={setAddClient}
                    setRoleType={setRoleType}
                    roleType={roleType}
                    createNewEmployee={createNewEmployee}
                    showEmployeesFilters={showEmployeesFilters}
                    setShowEmployeesFilters={setShowEmployeesFilters}
                    searchEmployeeQuery={searchEmployeeQuery}
                    handleSearchEmployeeChange={handleSearchEmployeeChange}
                    selectedEmployees={selectedEmployees}
                    adminEmployees={adminEmployees}
                    handleEmployeeSelection={handleEmployeeSelection}
                    handleAdminSelection={handleAdminSelection}
                    fetchAllClients={fetchAllClients}
                    showClientsFilters={showClientsFilters}
                    clientsIsLoading={clientsIsLoading}
                    clients={clients}
                    setShowClientsFilters={setShowClientsFilters}
                    searchClientQuery={searchClientQuery}
                    handleSearchClientChange={handleSearchClientChange}
                    clientsList={clientsList}
                    handleClientSelection={handleClientSelection}
                    selectedClients={selectedClients}
                    setNewClient={setNewClient}
                    setSelectedEmployees={setSelectedEmployees}
                    isCreateProject
                />
            </StyledDiv>
            <ConfirmModal
                toggle={handleToggle}
                isOpen={toggleModal}
                text={text?.inventory?.create?.modal?.button}
                onClick={() => resetForm()}
                width={isDesktop ? '50%' : '100%'}
                height={isDesktop ? '50%' : '100%'}
            >
                <div>
                    <h4 className='mb-md'>
                        {text?.inventory?.create?.modal?.title}
                    </h4>
                    <p>
                        {text?.inventory?.create?.modal?.subtitle}
                    </p>
                </div>
            </ConfirmModal>
            <ConfirmModal
                toggle={() => setShowSubscriptionOptions(false)}
                isOpen={showSubscriptionOptions}
                width={'100%'}
                height={'100%'}
            >
                <div className='w-100'>
                    <MembershipContainer
                        trialHasBeenUsed={company?.trialHasBeenUsed}
                        isLoggedIn={isLoggedIn}
                        fetchUserDetails={fetchUserDetails}
                        email={user?.email}
                        isPremium={user?.isPremium}
                        fetchCompanyDetails={fetchCompanyDetails}
                        company={company}
                        isCompanyPremium={company?.isPremium}
                    />
                </div>
            </ConfirmModal>
        </ConditionalRender >
    )
}

export default CreateProjectContainer